<template>
    <section id="contact" class="py-24 px-4 sm:px-6 lg:px-8 bg-slate-900">
      <div class="max-w-4xl mx-auto">
        <div class="text-center mb-16">
          <p class="text-emerald-400 text-sm font-semibold tracking-widest uppercase mb-3">Contact</p>
          <h2 class="text-3xl sm:text-4xl font-bold text-white mb-4">
            Let's work <span class="text-emerald-400">together</span>
          </h2>
          <p class="text-slate-400 max-w-xl mx-auto">
            I’m open to new opportunities and challenging projects.
Feel free to reach out — I’d be glad to connect.
          </p>
        </div>
        
        <div class="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 p-8 sm:p-12">
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-x-4 sm:gap-x-8 gap-y-12">
            <!-- Phone -->
            <div class="text-center sm:text-left">
              <div class="w-14 h-14 bg-teal-500/10 rounded-xl flex items-center justify-center mx-auto sm:mx-0 mb-4">
                <svg class="w-7 h-7 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-white mb-2">Phone</h3>
              <a href="tel:+251912473927" class="text-slate-400 hover:text-emerald-400 text-sm sm:text-base transition-colors">
                +251 912 473 927
              </a>
            </div>

            <!-- Telegram -->
            <div class="text-center sm:text-left">
              <div class="w-14 h-14 bg-blue-500/10 rounded-xl flex items-center justify-center mx-auto sm:mx-0 mb-4">
                <svg class="w-7 h-7 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.891 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.14-.26.26-.54.26l.213-3.05 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-white mb-2">Telegram</h3>
              <a href="https://t.me/Mx4321" target="_blank" class="text-slate-400 hover:text-emerald-400 text-sm sm:text-base transition-colors">
                @Mx4321
              </a>
            </div>

            <!-- Email -->
            <div class="text-center sm:text-left col-span-2 sm:col-span-1 pt-8 sm:pt-0 border-t sm:border-t-0 border-slate-700/50">
              <div class="w-14 h-14 bg-emerald-500/10 rounded-xl flex items-center justify-center mx-auto sm:mx-0 mb-4">
                <svg class="w-7 h-7 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-white mb-2">Email</h3>
              <a href="mailto:wendmsoft@gmail.com" class="text-slate-400 hover:text-emerald-400 text-sm sm:text-base transition-colors">
                wendmsoft@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
